<!-- Wrapper -->
<div
  class="flex flex-col flex-auto w-full min-w-0"
  [ngClass]="{ 'dark': isDarkTheme() }"
>
  <!-- Header -->
  <div
  class="relative flex flex-0 items-center w-full  h-12 sm:h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
  <ng-container *ngIf="!isScreenSmall">
      <!-- Logo -->
      <div class="flex justify-between  w-full">
      <div class="flex items-center mx-2 lg:mr-8">
          <div>
              <div class="hidden lg:flex">
                  <img class="dark:hidden w-48 ml-2" src="assets/logos/logo.png">
                  <img class="hidden dark:flex w-48 -ml-2" src="assets/logos/logo.png">
              </div>
              <img class="flex lg:hidden w-40 ml-2" src="assets/logos/logo.png">
          </div>
      </div>

      <!-- Horizontal navigation -->
      <!-- <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="navigation"
          (click)="click($event)">
      </fuse-horizontal-navigation> -->

      <ul class="menu flex gap-5">
          <li><a class="cursor-pointer text-lg font-semibold" (click)="redirectToHome()">Home</a></li>
          <li><a class="cursor-pointer text-lg font-semibold" (click)="redirectToLstVw()" >Track Request</a></li>
          <li *ngIf="isBusOpsAdmin()"><a class="cursor-pointer text-lg font-semibold" [routerLink]="['/usr/usr-svc/lst-vw']" >Customers</a></li>
          <li><a class="cursor-pointer text-lg font-semibold" [routerLink]="['/usr/usr-svc/dtl-vw']" >Profile</a></li>
          <li><a class="cursor-pointer text-lg font-semibold" (click)="logout()" >Logout</a></li>
      </ul>
  </div>



  </ng-container>
  <!-- Navigation toggle button -->
  <ng-container *ngIf="isScreenSmall">
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
  </ng-container>

  <div id="chat" class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!-- <user></user> -->
  </div>
</div>

  <!-- Content -->
  <div class="flex flex-col flex-auto w-full">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div
    class="relative flex flex-0 items-center justify-end w-full h-4 sm:h-6 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
  >
    <span class="font-medium text-secondary"
      >Nirjai &copy; {{currentYear}}</span
    >
  </div>
</div>
